<template>
  <div  style="padding-bottom: 400px;">
    <div class="mb-5 p-1">
      <graphic-orders :all-users="isTeamOrders"></graphic-orders>
    </div>
  <b-card v-if="false">
    <b-row>
        <b-col cols="12">
          <div class="demo-spacing-0">
            <b-alert
              show
              variant="warning"
            >
              <div class="alert-body">
                <i18n path="welcome_message_when_login_with_hash" tag="span">
                  <template v-slot:br><br /></template>
                  <template v-slot:_firstname_>{{ $store.state.userData.firstName }}</template>
                  <template v-slot:_italic_friends_><em>friends</em></template>
                  <template v-slot:_href_app_client_>
                    <a v-if="$i18n.locale === 'en'" href="https://closedcaptioner.com/friends/" target="_BLANK">https://closedcaptioner.com/friends</a>
                    <a v-else href="https://soustitreur.com/friends/" target="_BLANK">https://soustitreur.com/friends</a>
                  </template>
                  <template v-slot:_href_forgot_password_>
                    <a v-if="$i18n.locale === 'en'" href="https://closedcaptioner.com/friends/forgot-password/" target="_BLANK">setup a new password by clicking here</a>
                    <a v-else href="https://soustitreur.com/friends/forgot-password" target="_BLANK">choisir un mot de passe en cliquant ici</a>
                  </template>
                </i18n>
              </div>
            </b-alert>
          </div>
        </b-col>
      </b-row>
  </b-card>
  <b-card
    no-body
  >
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="4"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t('Entries') }}</label>
          <v-select
            v-model="perPage"
            @input="getMyOrders()"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="ml-50 mr-1"
          />
          <b-button
            v-show="!checkboxAll && !indeterminate"
            variant="link"
            href="#"
            disabled
            id="downloadAllBtnDisabled"
          >
            {{ $t('Download') }}
            <feather-icon
              icon="ChevronDownIcon"
              class="cursor-pointer"
              size="16"
            /> 
          </b-button>
          <b-tooltip
            :title="$t('Download selected items')"
            class="cursor-pointer"
            target="downloadAllBtnDisabled"
          />
          <b-dropdown
            variant="link"
            size="sm"
            :text="$t('Download')"
            no-caret
            dropright
            down
            boundary="window"
            id="downloadAllBtn"
            v-show="checkboxAll || indeterminate"
          >
            <template #button-content>
              <a href="#">
                {{ $t('Download') }}
                <feather-icon
                  icon="ChevronDownIcon"
                  class="cursor-pointer"
                  size="16"
                /> 
              </a>
            </template>
            <li>
              <b-dropdown 
                id="dropdown-2" 
                :text="$t('Video editing')" 
                variant="link"
                size="sm"
                no-caret
                ref="dropdown-2"
              >
                <template #button-content>
                  <a href="#">
                    {{ $t('Video editing') }}
                    <feather-icon
                      icon="ChevronDownIcon"
                      class="cursor-pointer"
                      size="16"
                    /> 
                  </a>
                </template>
                <b-dropdown-item
                  @click="downloadFiles('Sous-titres SRT')"
                >
                    {{ $t('Sous-titres SRT') }} 
                </b-dropdown-item>
                <b-dropdown-item
                  @click="downloadFiles('SRT Adobe Première Windows')"
                >
                    {{ $t('SRT Adobe Première Windows') }} 
                </b-dropdown-item>
                <b-dropdown-item
                  @click="downloadFiles('VTT')"
                >
                    {{ $t('VTT') }} 
                </b-dropdown-item>
              </b-dropdown>
            </li>
            <li>
              <b-dropdown 
                id="dropdown-2" 
                :text="$t('Transcription')" 
                variant="link"
                size="sm"
                no-caret
                ref="dropdown-2"
              >
                <template #button-content>
                  <a href="#">
                    {{ $t('Transcription') }}
                    <feather-icon
                      icon="ChevronDownIcon"
                      class="cursor-pointer"
                      size="16"
                    /> 
                  </a>
                </template>
                <b-dropdown-item
                  @click="downloadFiles('Transcription Texte')"
                >
                    {{ $t('Transcription Texte') }} 
                </b-dropdown-item>
                <b-dropdown-item
                  @click="downloadFiles('Transcription Texte avec Timecodes')"
                >
                    {{ $t('Transcription Texte avec Timecodes') }} 
                </b-dropdown-item>
              </b-dropdown>
            </li>
            <li>
              <b-dropdown
                id="dropdown-2"
                :text="$t('Pour la TV')"
                variant="link"
                size="sm"
                no-caret
                ref="dropdown-2"
                boundary="window"
              >
                <template #button-content>
                  <a href="#">
                    {{ $t('Pour la TV') }}
                    <feather-icon
                      icon="ChevronDownIcon"
                      class="cursor-pointer"
                      size="16"
                    /> 
                  </a>
                </template>
                <b-dropdown-item
                  @click="downloadFiles('Pour la TV: DropFrame - PopOn')"
                >
                    {{ $t('Pour la TV: DropFrame - PopOn') }} 
                </b-dropdown-item>
                <b-dropdown-item
                  @click="downloadFiles('Pour la TV: DropFrame - RollUp')"
                >
                    {{ $t('Pour la TV: DropFrame - RollUp') }} 
                </b-dropdown-item>
                <b-dropdown-item
                  @click="downloadFiles('Pour la TV: Non-DropFrame - PopOn')"
                >
                    {{ $t('Pour la TV: Non-DropFrame - PopOn') }} 
                </b-dropdown-item>
                <b-dropdown-item
                  @click="downloadFiles('Pour la TV: Non-DropFrame - RollUp')"
                >
                    {{ $t('Pour la TV: Non-DropFrame - RollUp') }} 
                </b-dropdown-item>
                <b-dropdown-item
                  @click="downloadFiles('Combiné 608/708-DF')"
                >
                    {{ $t('Combiné 608/708-DF') }} 
                </b-dropdown-item>
              </b-dropdown>
            </li>
          </b-dropdown>
          <b-tooltip
            :title="$t('Download selected items')"
            class="cursor-pointer"
            target="downloadAllBtn"
          />
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="d-flex align-items-center justify-content-between mb-1 mb-md-0"
        >
          <b-form-checkbox
            v-if="hasTeam"
            v-model="isTeamOrders"
            name="check-button"
            switch
            inline
            @change="handleTeamOrdersChange"
          >
          <span>{{ $t('Team Orders') }}</span>
          </b-form-checkbox>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              :value="searchQuery"
              @change="v => searchQuery = v"
              class="d-inline-block mr-1"
              :placeholder="$t('Search Order Number or Title...')"
            />
            <b-link
              variant="primary"
              block
              @click="getMyOrders"
            >
              <feather-icon
                icon="SearchIcon"
                size="16"
                class="cursor-pointer d-sm-block mr-50"
            />
            </b-link>
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="refOrderListTable"
      :items="orders"
      :busy.sync="isLoading"
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text= "$t('No matching records found')"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
      striped
      responsive
      :small="isTeamOrders"
      :fixed="isTeamOrders && setTableFixed"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>{{ $t('Loading') }}...</strong>
        </div>
      </template>
      <template #table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.ordernum"
        >
      </template>
      <template #head(download)="data">
        <b-form-checkbox
          v-model="checkboxAll"
          :indeterminate.sync="indeterminate"
          :key="keyCheckboxAll"
          class="mr-0 mt-50"
          name="is-rtl"
        />
      </template>
      <template #cell(download)="data">
        <b-form-checkbox
          v-if="data.item.hastranscriptcontent && data.item.progress >= 100"
          v-model="checkedItems"
          :value="data.item.id"
          class="mr-0 mt-50"
          name="is-rtl"
          ref="checkboxdownload"
        />
      </template>
      <!-- Column: Order Number -->
      <template #cell(ordernum)="data">
        <b-link
          :to="'/friends/login-with-hash/#' + data.item.hash"
          class="font-weight-bold"
          :id="parseInt($route.query.ordernum) == parseInt(data.item.ordernum) ? 'selectedOrder' : ''"
          :ref="parseInt($route.query.ordernum) == parseInt(data.item.ordernum) ? 'selectedOrder' : ''"
        >
          #{{ data.item.ordernum }}
        </b-link>
      </template>

      <!-- Column: Title -->
      <template #cell(title)="data">
          <p class="mb-0" v-if="data.item.title !== null">
            {{ data.item.title }}
          </p>
      </template>

      <!-- Column: Title -->
      <template #cell(user)="data">
          <p class="mb-0" v-if="data.item.userName !== null">
            {{ data.item.userName }}
          </p>
      </template>

      <!-- Column: Language -->
      <template #cell(language)="data">
          <p class="mb-0" v-if="data.item.language !== null">
            {{ $t(displayLanguageName(data.item.language)) }}
          </p>
          
      </template>

      <template #cell(progress)="data">
  <div style="display: flex; align-items: center; gap: 10px; padding: 10px 0;">
    <b-tooltip
      :title="$t(data.item.tooltip)"
      class="cursor-pointer"
      :target="`order-row-${data.item.id}-status`"
    />

    <span
      class="ml-2 cursor-pointer"
      :id="`order-row-${data.item.id}-details`"
      style="
        font-weight: bold;
        cursor: pointer;
        color: white;
        background-color: #17a2b8;
        border-radius: 50%;
        width: 35px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
      "
      @mouseover="getProgressDetails(data.item.id)"
    >
      ?
    </span>

    <b-tooltip 
  :target="`order-row-${data.item.id}-details`" 
  triggers="hover" 
  placement="right" 
  style="background-color: transparent;"
>
  <ul v-if="data.item.progressdetails && data.item.progressdetails.length" 
      style="list-style-type: none; padding: 10px; margin-top: -6px; margin-bottom: -6px; background-color: rgba(50,50,50,255); border-radius: 8px; width: 370px;">
    <li v-for="(detail, index) in data.item.progressdetails" 
        :key="index" 
        style="padding: 8px 0; display: flex; justify-content: space-between; border-bottom: 1px solid rgba(255, 255, 255, 0.2);">
      <span style="font-weight: bold; color: white;">{{ detail.message }}</span>
      <span v-if="detail.status === 'Completed'" style="color: #28a745;">✅</span>
      <span v-else-if="detail.status === 'In Progress'" style="color: #ffc107;">❌</span>
      <span v-else style="color: #dc3545;">❌</span>
    </li>
    <br/>
    <b-progress
      :value="data.item.progress"
      max="100"
      :variant="data.item.variant"
      striped
      :id="`order-row-${data.item.id}-status`"
      style="flex-grow: 1; width: 100%; border-radius: 8px;"
    />
  </ul>
  <b-spinner small v-else></b-spinner>
</b-tooltip>
  </div>
</template>

      <template #cell(date)="data">
        <span class="text-nowrap">
          {{ data.item.date }}
        </span>
      </template>

      <template #cell(edit)="data">
        <div class="text-nowrap text-left">
          <b-button
          v-if="data.item.canedit && data.item.progress >= 100"
          :id="`order-row-${data.item.id}-edit`" 
          :href="data.item.getEditorLink"
          target="_blank"
          variant="link"
          toggle-class="p-0"
          size="sm"
          >
            {{ $t("Edit") }}
          </b-button>
          <b-tooltip
            v-if="data.item.canedit"
            :title="$t('Subtitle editor')"
            class="cursor-pointer"
            :target="`order-row-${data.item.id}-edit`"
          />
          <br />
          <b-button
            v-if="data.item.cancancel"
            @click="popupModalCancelItem(data.item.id)"
            size="sm"
            variant="link"
            toggle-class="p-0">
              {{ $t("Cancel item") }}
          </b-button>
        </div>
      </template>
      <template #cell(review)="data">
        <div class="text-nowrap text-left" v-if="data.item.hastranscriptcontent && data.item.progress >= 100">
          <b-dropdown
            :ref="`dropdown-review-${data.item.id}`"
            variant="link"
            size="sm"
            :text="$t('Note Quality')"
            no-caret
            right
          >
            <template #button-content>
              <a :id="`order-row-${data.item.id}-review-icon`" href="#">
                {{ $t("Note Quality") }}
              </a>
            </template>
            <b-dropdown-form class="py-1">
              <h4>Note la qualité des sous-titres que tu as reçus</h4>
              <div class="container text-center">
                <b-form-rating
                  :ref="`dropdown-review-note-${data.item.id}`"
                  no-border
                  v-model="data.item.reviewNote"
                  inline
                  size="lg"
                  variant="warning"
                  @change="data.item.reviewNote > 3 ? saveNote(data.item.id, data.item.reviewNote, data.item.reviewComment) : ''"
                />
              </div>
              <a href="http://Facebook.com/SousTitreur/reviews" v-if="data.item.reviewNote > 3" style="text-align: center;" target="_blank">{{ $t('Wow, tu es enthousiaste ! Veux-tu nous écrire un avis sur Facebook ?') }}</a>
              <div class="container text-center" v-if="data.item.reviewNote !== null && data.item.reviewNote < 4">
                <b-form-textarea
                  id="textarea-review-comment"
                  :value="data.item.reviewComment"
                  @change="v => data.item.reviewComment = v"
                  :placeholder="$t('Qu’aurions-nous pu améliorer ?')"
                  rows="2"
                  max-rows="8"
                  no-auto-shrink
                />
                <br />
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  @click="saveNote(data.item.id, data.item.reviewNote, data.item.reviewComment)"
                >
                  {{ $t("Save note")}}
                </b-button>
              </div>
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </template>
      <!-- Column: Action-->
      <template #cell(action)="data">
        <div class="text-nowrap text-left" v-if="data.item.hastranscriptcontent && data.item.progress >= 100" @mouseover="onOver(`dropdown-1-${data.item.id}`)">
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            size="sm"
            :text="$t('Download')"
            no-caret
            :ref="`dropdown-1-${data.item.id}`"
            dropleft
            down
            @mouseleave="onLeave(`dropdown-1-${data.item.id}`)"
          >
            <template #button-content>
              <a :id="`order-row-${data.item.id}-download-icon`" href="#">
                {{ $t('Download') }}
                <feather-icon
                  icon="ChevronDownIcon"
                  class="cursor-pointer"
                  size="16"
                /> 
              </a>
            </template>
            <b-dropdown-form v-show="isShowVideoEdittingItems === true">
              <a class="subtitle-download-btn" @click="isShowVideoEdittingItems = false">
                {{ $t('Video editing') }}
                <feather-icon
                  icon="ChevronUpIcon"
                  class="cursor-pointer"
                  size="16"
                />
              </a>
              <li
                v-for="option in data.item.downloadsrtoptions" 
                :key="option.url">
                <a
                  class="subtitle-download-btn-item"
                  @click="clickedDownload(option.url, data.item.id)"
                >{{ $t(option.text) }}</a>
              </li>
            </b-dropdown-form>
            <b-dropdown-form v-show="isShowVideoEdittingItems === false">
              <a class="subtitle-download-btn" @click="isShowVideoEdittingItems = true">
                {{ $t('Video editing') }}
                <feather-icon
                  icon="ChevronDownIcon"
                  class="cursor-pointer"
                  size="16"
                />
              </a>
            </b-dropdown-form>
            <b-dropdown-form v-show="isShowTranscriptionItems === true">
              <a class="subtitle-download-btn" @click="isShowTranscriptionItems = false">
                {{ $t('Transcription') }}
                <feather-icon
                  icon="ChevronUpIcon"
                  class="cursor-pointer"
                  size="16"
                />
              </a>
              <li
                v-for="option in data.item.downloadtranscriptionoptions" 
                :key="option.url">
                <a
                  class="subtitle-download-btn-item"
                  @click="clickedDownload(option.url, data.item.id)"
                >{{ $t(option.text) }}</a>
              </li>
            </b-dropdown-form>
            <b-dropdown-form v-show="isShowTranscriptionItems === false">
              <a class="subtitle-download-btn" @click="isShowTranscriptionItems = true">
                {{ $t('Transcription') }}
                <feather-icon
                  icon="ChevronDownIcon"
                  class="cursor-pointer"
                  size="16"
                />
              </a>
            </b-dropdown-form>
            <b-dropdown-form v-show="isShowForTVItems === true">
              <a class="subtitle-download-btn" @click="isShowForTVItems = false">
                {{ $t('Pour la TV') }}
                <feather-icon
                  icon="ChevronUpIcon"
                  class="cursor-pointer"
                  size="16"
                />
              </a>
              <li
                v-for="option in data.item.downloadtvoptions" 
                :key="option.url">
                <a
                  class="subtitle-download-btn-item"
                  @click="clickedDownload(option.url, data.item.id)"
                  :ref="`${option.url}`"
                >{{ $t(option.text) }}</a>
              </li>
            </b-dropdown-form>
            <b-dropdown-form v-show="isShowForTVItems === false">
              <a class="subtitle-download-btn" @click="isShowForTVItems = true">
                {{ $t('Pour la TV') }}
                <feather-icon
                  icon="ChevronDownIcon"
                  class="cursor-pointer"
                  size="16"
                />
              </a>
            </b-dropdown-form>
            <b-dropdown-item
              @click="downloadOriginalVideo(data.item.id)"
            >
                {{ $t('Download Original Video File') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="data.item.canorderburn === true" 
              @click="burnModalOpen(data.item)"
            >
                {{ $t('Order') + ' ' + $t('Video with permanent embedded subtitles') + ' ' + currencySymbols + currencyMultiplier*data.item.duration*(burnpromo !== false ? burnpromo : 2) }}
            </b-dropdown-item>
            <b-dropdown-item v-else-if="data.item.toburn === '1' && data.item.burnfinalfilename === null" 
              disabled
            >
              {{ $t('Burning video. Come back in a few minutes...') }}
            </b-dropdown-item>
            <template v-else-if="data.item.canreburn !== false" >
              <b-dropdown-item @click="reburnthevideo(data.item.id, data.item.burnstyle)">
                {{ $t('Reburn my last edits to the video') }}
              </b-dropdown-item>
              <b-dropdown-item @click="burnModalOpen(data.item)">
                {{ $t('Reburn video with a different style') }}
              </b-dropdown-item>
              <b-dropdown-item
                target="_blank"
                :href="data.item.burnfinalfilename + '?v=' + getTimestamp()"
              >
                {{ $t('Video with permanent embedded subtitles') }}
            </b-dropdown-item>
            </template>
            <template v-else-if="data.item.burnfinalfilename !== null" >
              <b-dropdown-item @click="reburnthevideo(data.item.id, data.item.burnstyle)">
                {{ $t('Reburn my last edits to the video') }}
              </b-dropdown-item>
              <b-dropdown-item @click="burnModalOpen(data.item)">
                {{ $t('Reburn video with a different style') }}
              </b-dropdown-item>
              <b-dropdown-item 
                target="_blank"
                :href="data.item.burnfinalfilename + '?v=' + getTimestamp()"
              >
                {{ $t('Video with permanent embedded subtitles') }}
              </b-dropdown-item>
            </template>
            <b-dropdown-item v-for="language in data.item.orderlanguages" 
              :key="language.code" 
              :value="language.code"
              @click="orderTranslation(data.item.id, language.code)"
            >
                {{ $t('Order translation for') + ' ' + $t(language.name) + ' ' + currencySymbols + (data.item.orderHasQuality ? currencyMultiplier*data.item.duration*6 : currencyMultiplier*data.item.duration*2) }}
            </b-dropdown-item>
            <b-dropdown-divider :ref="`dropdown-divider-${data.item.id}`" style="display:none"></b-dropdown-divider>
            <b-dropdown-form :ref="`dropdown-form-${data.item.id}`" style="display:none">
              <div class="container text-center">
                <a>
                  {{ $t('Note the quality of the work you received,') }}<br />{{ $t('and get a chance to win $100 Amazon') }}
                </a>
              </div>
              <div class="container text-center">
                <b-form-rating
                  no-border
                  v-model="data.item.reviewNote"
                  inline
                  size="lg"
                  variant="warning"
                  @change="rateReview(data.item.id, data.item.reviewNote, data.item.reviewComment)"
                />
              </div>
              <div class="container text-center" v-show="isRated[data.item.id]">
                <a>{{ $t('Thanks! You are personally added to the monthly draw.') }}</a>
              </div>
            </b-dropdown-form>
          </b-dropdown>
        </div>
      </template>
    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">{{ $t('Showing') + ' ' + dataMeta.from + ' ' + $t('to') + ' ' + dataMeta.to + ' ' + $t('of') + ' ' + dataMeta.of + ' ' + $t('entries') }}</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            @change="getMyOrders"
            :total-rows="totalOrder"
            :per-page="perPage.value === 0 ? totalOrder : perPage.value"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            :key="currentPage"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
  <b-modal
    v-model="showModalCancelItem"
    :title="$t('Cancel item')"
    header-bg-variant="danger"
    header-text-variant="light"
    :hide-header-close="true"
  >
    <h4>{{ $t('Are you sure you want to cancel this file ?') }}</h4>
    <template #modal-footer>
        <b-button variant="outline-danger" class="float-right" @click="cancelItem" size="sm" :disabled="isloadingCancelItem"><b-spinner v-if="isloadingCancelItem" class="align-middle"></b-spinner>Yes</b-button>
        <b-button variant="danger" class="float-right" @click="showModalCancelItem = false" size="sm">No</b-button>
    </template>
  </b-modal>
  <b-modal
    v-model="showModalBurnOptions"
    :title="$t('Burn options')"
    :ok-title="burnModalOkTitle"
    @ok="burnItem"
    header-bg-variant="success"
    header-text-variant="light"
    size="lg"
    :hide-header-close="true">
    <div class="burn-options-body">
      <h3>{{$t("Choose one of our subtitle styles")}}</h3>
      <div v-if="availableBurnStyles === null || selectedBurnItem === null">
        <b-spinner variant="success" label="Spinning"></b-spinner>
      </div>
      <div v-else>
        <div label="Burn Styles" style="display: grid; grid-template-columns: 45% 45%; grid-gap: 1%;">
          <div v-for="style in availableBurnStyles" :key="style">
            <b-form-radio v-model="selectedBurnStyle" :aria-describedby="style" name="burnstyle" :value="style" >
              {{style}}
              <span :id="style" class="onhover-pointer">ⓘ</span>
            </b-form-radio>
            <b-popover :target="style" triggers="hover" placement="top">
              <template #title>{{style}}</template>
              <img :src="`${domain}/images/${style}.png`" class="w-100 img-fluid"/>
            </b-popover>
          </div>
          <div>
            <label>{{$t("Vertical Margin Percentage")}}</label>
            <b-form-input
              v-model="newPercentage"
              @change="v => newPercentage = v"
              :placeholder="$t('Vertical Margin Percentage')"
              type="number"
            />
            <b-button @click="resetDefault()">{{$t('Reset to default')}}</b-button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</div>
</template>
<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,
  BSpinner, BProgress, BFormCheckbox, BAlert, BDropdownForm,
  BFormRating, BFormTextarea, BIcon, BDropdownDivider, BDropdownItemButton,
  BDropdownGroup, BPopover, BFormRadio,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Config from '@/libs/config';
import Apicall from '@/libs/api-call'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import JSZip from 'jszip' 
import saveAs from 'save-as';
import moment from 'moment';
import Axios from '@axios';
import GraphicOrders from '@/components/GraphicOrders.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    vSelect,
    ToastificationContent,
    BProgress,
    BFormCheckbox,
    BAlert,
    BDropdownForm,
    BFormRating,
    BFormTextarea,
    BIcon,
    BDropdownDivider,
    BDropdownItemButton,
    BDropdownGroup,
    BPopover,
    BFormRadio,
    GraphicOrders,
  },
  data() {
    return {
      progressList: [],
      selectedOrderId: null,
      selectedProgress: [],
      isTeamOrders: false,
      orderListOption: { value: 'myorder', label: 'My Orders' },
      currentPage: 1,
      totalOrder: 0,
      dataMeta: {
        from: 0,
        to: 0,
        of: 0
      },
      tableColumns: [
        { key: 'download' },
        { key: 'ordernum', label: this.$t('Order'), sortable: true },
        { key: 'title', label: this.$t('Title'), 'class': 'title-max-width' },
        { key: 'language', label: this.$t('Language') },
        { key: 'progress', label: this.$t('Progress') },
        { key: 'date', label: this.$t('Date command') },
        { key: 'review', label: this.$t('Note Quality') },
        { key: 'edit', label: this.$t('Edit') },
        { key: 'action', label: this.$t('Action') },
      ],
      Options: [
        { value: 'myorders', label: 'My Orders', selected: true },
        { value: 'teamorders', label: 'Team Orders' },
      ],
      searchQuery: '',
      sortBy: "ordernum",
      isSortDirDesc: true,
      orders: [],
      datefrom: '',
      dateto: '',
      isLoading: false,
      isDropdown2Visible: false,
      currencySymbols: '$',
      burnpromo: false,
      userCurrency: 'usd',
      currencyMultiplier: 1,
      perPage: { value: 25, label: '25' },
      perPageOptions: [
        { value: 0, label: this.$t('All') },
        { value: 10, label: '10' },
        { value: 25, label: '25' },
        { value: 50, label: '50' },
        { value: 100, label: '100' },
      ],
      hasTeam: false,
      loadingFirstTime: true,
      setTableFixed: false,
      showModalCancelItem: false,
      showModalBurnOptions: false,
      availableBurnStyles: null,
      selectedBurnItem: null,
      selectedBurnStyle: 'OLDSCHOOL',
      burnstylemarginpercentage: {
        FRANKLIN: 13.1,
        HENDRIX: 29.3,
        NEUEHAAS: 8.3,
        NEWHOUSE: 16.9,
        NIMBUS: 12.2,
        VISTOL: 18.1,
        ROSEWELL: 22.3,
        LUXOR: 15.6,
        MANROPE: 21,
        PHOSPHATE: 16.9,
        SHELF: 16.9,
        HAMMERSMITH: 13.1,
        METROPOLIS: 13.1,
        RUBIK: 13.1,
        PERSPECTIVE: 64.8,
        PROZA: 54,
        WLM: 13,
        METROPOLIS_REMIX: 13.1,
        OLDSCHOOL: 10,
        OSWALD: 80,
        KELSON: 110,
        INTER: 80,
        ROCKO: 120,
        SIGMAR: 60,
        ROBOTO: 225,
        VIRTUCORP: 120,
        RALEWAY: 120,
        SMALLROBOTO: 80,
      },
      newPercentage: 0,
      defaultPercentage: 0,
      burnModalOkTitle: 'Add burn',
      cancelItemId: null,
      isloadingCancelItem: false,
      indeterminate: false,
      checkedItems: [],
      tempCheckedAllItems: [],
      checkboxAll: false,
      keyCheckboxAll: 0,
      files: [],
      isRated: [],
      isShowVideoEdittingItems: true,
      isShowTranscriptionItems: false,
      isShowForTVItems: false,
      domain: Config.basedomain,
      allUsers: false,
      type: null,
      isFetchingProgress: {},
    }
  },
  watch: {
    progressList(newValue) {
    console.log('Datos actualizados en progressList:', newValue);
  },
    '$i18n.locale': function(newVal, oldVal) {
      this.reloadTable(false);
    },
    isTeamOrders: function(newVal, oldVal) {
      this.currentPage = 1;
      this.reloadTable(true);
    },
    isLoading: function(newVal) {
      if (newVal === false && this.orders.length > 0) {
        setTimeout(() => {
          const el = document.getElementById('selectedOrder');
          if (el && this.isTeamOrders === false) {
            el.scrollIntoView({behavior: "smooth", block: "center"});
          } 
        }, 200);
      }
    },
    checkedItems: function(newVal) {
      if (newVal.length === 0) {
        this.checkboxAll = false;
        this.indeterminate = false;
      } else if (newVal.length < this.tempCheckedAllItems.length) {
        this.checkboxAll = false;
        this.indeterminate = true;
        this.keyCheckboxAll++; 
      } 
      if (newVal.length === this.tempCheckedAllItems.length) {
        this.indeterminate = false;
        this.checkboxAll = true;
        this.keyCheckboxAll++; // re-render the checkbox
      }
    },
    checkboxAll: function(newVal) {
      if (newVal === true) {
        this.checkedItems = this.tempCheckedAllItems;
      } else if (newVal === false && this.indeterminate === false) {
        this.checkedItems = [];
      }
    },
    selectedBurnStyle: function(newVal) {
      if (newVal && this.selectedBurnItem) {
        this.changeBurnModalOkTitle();
        this.getBurnStyleMarginPercentage()
      }
    },
    showModalBurnOptions: function(newVal) {
      if (newVal) {
        const api = new Apicall();

        api.getAvailableBurnStyles().then(response => {
          if (response.status === "OK") {
            this.availableBurnStyles = response.data.data.styles;
            if (this.selectedBurnItem !== null) {
              this.selectedBurnStyle = 
                this.availableBurnStyles.indexOf(this.selectedBurnItem.burnstyle) !== -1 ?
                this.selectedBurnItem.burnstyle :
                "OLDSCHOOL";
              this.changeBurnModalOkTitle();
              this.getBurnStyleMarginPercentage()
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t(response.msg),
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            });
          }
        });
        
      } else {
        this.availableBurnStyles = null;
        this.selectedBurnItem = null;
        this.selectedBurnStyle = null;
      }
    },
  },
  mounted() {
    this.dateto = moment().format('Y-MM-DD');
    this.datefrom = moment().subtract(90, 'd').format('Y-MM-DD');
    this.minutesAndFilesOrderedByDay();
    this.checkForPromo();
    this.getMyOrders();
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if(bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if(bvEvent.componentId === 'dropdown-2') {
        this.isDropdown2Visible = false;
      }
      if(this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
    if (window.matchMedia("(min-width: 768px)").matches) {
      this.setTableFixed = true;
    }
  },
  methods: {
    checkForPromo() {
      const api = new Apicall()
      api.checkBurnPromo().then((response) => {
        if (response.status !== "ERROR") {
          if (response.data.data.promoburnprice !== null) {
            this.burnpromo = response.data.data.promoburnprice;
          }
        }
      });
    },
    burnModalOpen(orderitem) {
      this.selectedBurnItem = orderitem;
      this.showModalBurnOptions = true;
    },
    changeBurnModalOkTitle() {
        if (this.selectedBurnItem.toburn === "0") {
          this.burnModalOkTitle = this.$t('Order') + ' ' + this.$t('Video with permanent embedded subtitles') + ' ' + 
            this.currencySymbols + this.currencyMultiplier*this.selectedBurnItem.duration*(this.burnpromo !== false ? this.burnpromo : 2);
        } else if (this.selectedBurnItem.canreburn !== false) {
          this.burnModalOkTitle = this.$t('Reburn my last edits to the video');
        } else if (this.selectedBurnItem.burnfinalfilename !== null) {
          this.burnModalOkTitle = this.$t('Reburn my last edits to the video');
        }
    },
    burnItem() {
      if (this.selectedBurnItem) {
        if (this.selectedBurnItem.toburn === "0") {
          this.orderBurnVideo(this.selectedBurnItem.id, this.selectedBurnStyle, this.newPercentage, this.defaultPercentage);
        } else if (this.selectedBurnItem.canreburn !== false) {
          this.reburnthevideo(this.selectedBurnItem.id, this.selectedBurnStyle, this.newPercentage, this.defaultPercentage);
        } else if (this.selectedBurnItem.burnfinalfilename !== null) {
          this.reburnthevideo(this.selectedBurnItem.id, this.selectedBurnStyle, this.newPercentage, this.defaultPercentage);
        }
      }
    },
    handleTeamOrdersChange(newValue) {
      this.getMyOrders()
      this.$emit('update-team-orders', newValue)
    },
    getMyOrders() {
      this.indeterminate = false;
      this.checkboxAll = false;
      const api = new Apicall()
      this.isLoading = true;
      if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.orderListOption.value = this.isTeamOrders ? "teamorders" : "myorders";
        api.getUserOrders({
          keyword: this.searchQuery,
          orderListOption: this.orderListOption,
          perPage: this.perPage.value,
          page: this.currentPage,
          loadingFirstTime: this.loadingFirstTime,
          selectedOrdernum: this.$route.query.ordernum ? this.$route.query.ordernum : null,
        })
        .then(response => {
          if (response.status === "OK") {
            this.orders = response.data.orderitems;
            this.totalOrder = response.data.total;
            if (this.totalOrder > 500 && this.isTeamOrders === true && this.perPage.value === 0) {
              this.perPage = { value: 100, label: '100' };
            }
            if (this.loadingFirstTime === true && response.data.pageNumber > 0) {
              this.currentPage = response.data.pageNumber;
            }
            this.calculateDataMeta();
            this.userCurrency = response.data.userCurrency;
            this.currencySymbols = response.data.currencysymbols;
            switch (this.userCurrency) {
              case 'cad':
                this.currencyMultiplier = 1.5;
                break;
              case 'eur':
              default:
                this.currencyMultiplier = 1;
                break;
            }
            this.hasTeam = response.data.hasTeam;
            var selectedOrdernum = this.$route.query.ordernum;
            if (selectedOrdernum != '') {
              for(var i=0; i<this.orders.length; i++){
                if (this.orders[i].ordernum === selectedOrdernum) {
                  this.orders[i]._rowVariant = 'success';
                }
              }
            }
            for(var i=0; i<this.orders.length; i++){
              if (this.orders[i].hastranscriptcontent) {
                this.tempCheckedAllItems.push(this.orders[i].id);
                this.checkedItems = [];
              }
              this.isRated[this.orders[i].id] = false;
            }
            this.isLoading = false;
          } else {
            if (response.statuscode === 401) this.$router.push('Login');
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t(response.msg),
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            });
          }
          this.loadingFirstTime = false;
        })
        .catch(() => {
          this.isLoading = false;  
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t("Error fetching orders' list"),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
      }, 200);
    },
    getProgressDetails(orderId) {
  
  const order = this.orders.find(order => order.id === orderId);
  
  
  if (this.isFetchingProgress[orderId] || (order && order.progressdetails && order.progressdetails.length > 0)) {
    return;
  }

  this.$set(this.isFetchingProgress, orderId, true);
  
  const api = new Apicall();

  api.postProgress(orderId)
    .then(response => {
      if (response.status === 'OK') {
  
        this.orders = this.orders.map(order => {
          if (order.id === orderId) {
            order.progressdetails = response.data.data.progress;
            order.progress = this.calculateProgressSummary(response.data.data.progress);
          }
          return order;
        });
      } else {
        console.error('Error getting progress details:', response.msg);
      }
    })
    .catch(error => {
      console.error('Progress request failed:', error);
    })
    .finally(() => {
      this.$set(this.isFetchingProgress, orderId, false);
    });
},

  calculateProgressSummary(progressDetails) {
    const completedItems = progressDetails.filter(detail => detail.status === 'Completed');
    const totalItems = progressDetails.length;
    return (completedItems.length / totalItems) * 100;
  },
    calculateDataMeta() {
      var limit = this.perPage.value;
      if (limit > 0) {
        this.dataMeta.from = limit * (this.currentPage - 1) + (this.orders.length ? 1 : 0);
        this.dataMeta.to = limit * (this.currentPage - 1) + this.orders.length;
      } else {
        this.dataMeta.from = 1;
        this.dataMeta.to = this.totalOrder;
      }
      this.dataMeta.of = this.totalOrder;
    },
    dateTimeConvert(_unix_timestamp) {
      if (!_unix_timestamp) return null;
      let date = new Date(_unix_timestamp * 1000);
      let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour12: false  };
      let locale = this.$i18n.locale;
      if (this.$i18n.locale === 'en') {
        locale = "en-US";
      } else {
        locale = "fr-CA";
      }
      return date.toLocaleString(locale, options);
    },
    displayLanguageName(_locale) {
      // Get display names of language in English
      let languageNames = new Intl.DisplayNames(['en'], {type: 'language'});
      return languageNames.of(_locale);
    },
    goToEditPage(_url) {
      window.open(_url, '_blank').focus();
    },
    randomNumber() {
      // Getting a random integer between two values
      min = Math.ceil(0);
      max = Math.floor(20000);
      return Math.floor(Math.random() * (max - min) + min);
    },
    getTimestamp() {
      const timestamp = new Date().getTime();
      return timestamp;
    },
    callajax(_url) {
      this.$http.get(_url)
      .then(response => {
        if (response.status === 200 && response.data.status === 'success') {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              variant: 'success',
              title: this.$t('Ordered ! You will receive an invoice and the order very fast.'),
              icon: 'CheckIcon'
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              variant: 'danger',
              title: this.$t(response.msg),
              icon: 'XIcon',
            },
          });
        }
      })
    },
    openNewTab(_href) {
      window.open(_href, '_blank');
    },
    onOver(element) {
      this.$refs[element].visible = true;
    },
    onLeave(element) {
      this.$refs[element].visible = false;
    },
    saveNote(_id, _reviewNote, _reviewComment) {
      if (_reviewNote > 0) {
        this.apiSaveReview(_id, _reviewNote, _reviewComment);
        if (_reviewNote < 4) {
          this.$refs['dropdown-review-' + _id].visible = false;
        }
      }
    },
    minutesAndFilesOrderedByDay() {
      const api = new Apicall();

      // this.type = "TRANSLATION";
      // this.type = "CAPTIONING";
      // this.allUsers = true;
      // api.getMinutesAndFilesOrderedByDay(this.datefrom, this.dateto, this.allUsers, this.type)
      // .then((response) => {
      //   console.log(response);
      // })
    },
    apiSaveReview(_id, _reviewNote, _reviewComment) {
      const api = new Apicall();
      if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
      }
      this.timer = setTimeout(() => {
        api.postSaveReviewOrderItem(_id, _reviewNote, _reviewComment)
        .then(response => {
          if (response.status === "OK") {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                variant: 'success',
                title: this.$t('save_review_note_success'),
                icon: 'CheckIcon'
              },
            });
          } else {
            if (response.statuscode === 401) this.$router.push('Login');
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t(response.msg),
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            });
          }
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t("Error saving review note"),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
      }, 200);
    },
    reloadTable(_isSwitchButtonTeamOrders = false) {
      if (_isSwitchButtonTeamOrders === true) {
        this.orders = [];
        this.$refs.refOrderListTable.refresh();
      }
      if (window.matchMedia("(min-width: 768px)").matches) {
        this.setTableFixed = true;
      } else {
        this.setTableFixed = false;
      }
      this.tableColumns = this.$store.state.userData.role === 'ADMIN' && this.isTeamOrders === true ? [
        { key: 'download' },
        { key: 'ordernum', label: this.$t('Order'), sortable: true },
        { key: 'title', label: this.$t('Title'), 'class': 'title-max-width' },
        { key: 'user', label: this.$t('User') },
        { key: 'language', label: this.$t('Language') },
        { key: 'progress', label: this.$t('Progress') },
        { key: 'date', label: this.$t('Date command') },
        { key: 'review', label: this.$t('Note Quality') },
        { key: 'edit', label: this.$t('Edit') },
        { key: 'action', label: this.$t('Action') },
      ]
      : [
        { key: 'download' },
        { key: 'ordernum', label: this.$t('Order'), sortable: true },
        { key: 'title', label: this.$t('Title'), 'class': 'title-max-width' },
        { key: 'language', label: this.$t('Language') },
        { key: 'progress', label: this.$t('Progress') },
        { key: 'date', label: this.$t('Date command') },
        { key: 'review', label: this.$t('Note Quality') },
        { key: 'edit', label: this.$t('Edit') },
        { key: 'action', label: this.$t('Action') },
      ];
      this.perPageOptions = [
        { value: 0, label: this.$t('All') },
        { value: 10, label: '10' },
        { value: 25, label: '25' },
        { value: 50, label: '50' },
        { value: 100, label: '100' },
      ];
      if (this.perPage.value === 0) {
        this.perPage.label = this.$t('All');
      }
    },
    downloadOriginalVideo(_orderitemId) {
      const api = new Apicall();
      if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
      }
      this.timer = setTimeout(() => {
        api.checkUrlDownloadOriginalVideo(_orderitemId)
        .then(response => {
          if (response.status === "OK") {
            if (response.data.fileExists) {
              const originalvideoLink = response.data.originallink;
              window.open(originalvideoLink, '_blank');
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t("The file is not available anymore"),
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              });
            }
          } else {
            if (response.statuscode === 401) this.$router.push('Login');
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t(response.msg),
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            });
          }
        })
      }, 100);
    },
    reburnthevideo(_orderitemId, selectedBurnStyle = null, newPercentage = 0, defaultPercentage = 0) {
      const api = new Apicall();
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        api.reburn(_orderitemId, selectedBurnStyle, newPercentage, defaultPercentage)
        .then(response => {
          if (response.status === "OK") {
            if (response.data.status === "OK") {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  variant: 'success',
                  title: this.$t('Reburn Video success'),
                  icon: 'CheckIcon'
                },
              });
              this.getMyOrders();
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t(response.data.msg),
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              });
            }
          } else {
            if (response.statuscode === 401) this.$router.push('Login');
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t(response.msg),
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            });
          }
        })
      }, 100);
    },
    orderBurnVideo(_orderitemid, selectedBurnStyle = "OLDSCHOOL", newPercentage = 0, defaultPercentage = 0) {
      this.isLoading = true;
      const api = new Apicall();
      api.orderBurnVideo(_orderitemid, selectedBurnStyle, newPercentage, defaultPercentage)
      .then(response => {
        if (response.status === "OK") {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              variant: 'success',
              title: this.$t('Ordered ! You will receive an invoice and the order very fast.'),
              icon: 'CheckIcon'
            },
          });
          this.getMyOrders();
        } else {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t(response.msg),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        }
      })
    },
    orderTranslation(_orderitemid, _language) {
      this.isLoading = true;
      const api = new Apicall();
      api.orderTranslation(_orderitemid, _language)
      .then(response => {
        if (response.status === "OK") {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              variant: 'success',
              title: this.$t('Ordered ! You will receive an invoice and the order very fast.'),
              icon: 'CheckIcon'
            },
          });
          this.getMyOrders();
        } else {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t(response.msg),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        }
      })
    },
    popupModalCancelItem(_orderitemid) {
      this.cancelItemId = _orderitemid;
      this.showModalCancelItem = true;
    },
    cancelItem() {
      this.isloadingCancelItem = true;
      const api = new Apicall();
      api.cancelItem(this.cancelItemId)
      .then(response => {
        this.isloadingCancelItem = false;
        this.getMyOrders();
        this.showModalCancelItem = false;
        if (response.status === "OK") {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              variant: 'success',
              title: this.$t('Files cancelled. You will receive a credited invoice.'),
              icon: 'CheckIcon'
            },
          });
        } else {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t(response.msg),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        }
      })
    },
    downloadFiles(type) {
      this.files = [];
      let filezipname = '';
      const hostname = this.getHostname();
      if (this.checkedItems.length) {
        let downloadoption = null;
        let filename = '';
        let tempArray = [];
        this.checkedItems.forEach(itemid => {
          this.orders.forEach(item => {
            if (item.id === itemid && item.downloadsrtoptions.length) {
              downloadoption = null;
              switch (type) {
                case 'Sous-titres SRT':
                  downloadoption = item.downloadsrtoptions[0];
                  filezipname = `all_srt_${(new Date().toJSON().slice(0,10))}.zip`;
                  break;
                case 'SRT Adobe Première Windows':
                  downloadoption = item.downloadsrtoptions[1];
                  filezipname = `srt_adobe_premiere_windows_${(new Date().toJSON().slice(0,10))}.zip`;
                  break;
                case 'VTT':
                  downloadoption = item.downloadsrtoptions[2];
                  filezipname = `vtt_${(new Date().toJSON().slice(0,10))}.zip`;
                  break;
                case 'Transcription Texte':
                  downloadoption = item.downloadtranscriptionoptions[0];
                  filezipname = `text_transcription_${(new Date().toJSON().slice(0,10))}.zip`;
                  break;
                case 'Transcription Texte avec Timecodes':
                  downloadoption = item.downloadtranscriptionoptions[1];
                  filezipname = `text_transcription_with_timecode_${(new Date().toJSON().slice(0,10))}.zip`;
                  break;
                case 'Pour la TV: DropFrame - PopOn':
                  downloadoption = item.downloadtvoptions[0];
                  filezipname = `dropframe-popon_${(new Date().toJSON().slice(0,10))}.zip`;
                  break;
                case 'Pour la TV: DropFrame - RollUp':
                  downloadoption = item.downloadtvoptions[1];
                  filezipname = `dropframe-rollup_${(new Date().toJSON().slice(0,10))}.zip`;
                  break;
                case 'Pour la TV: Non-DropFrame - PopOn':
                  downloadoption = item.downloadtvoptions[2];
                  filezipname = `nondropframe-popon_${(new Date().toJSON().slice(0,10))}.zip`;
                  break;
                case 'Pour la TV: Non-DropFrame - RollUp':
                  downloadoption = item.downloadtvoptions[3];
                  filezipname = `nondropframe-rollup_${(new Date().toJSON().slice(0,10))}.zip`;
                  break;
                case 'Combiné 608/708-DF':
                  downloadoption = item.downloadtvoptions[4];
                  filezipname = `mcc_${(new Date().toJSON().slice(0,10))}.zip`;
                  break;
                default:
                  break;
              }
              if (downloadoption !== null) {
                filename = this.getFilenameFromUrl(downloadoption.url)
                this.files.push({ url: hostname + downloadoption.url, filename: filename });
              }
            }
          });
        });
      }
      this.saveZip(filezipname, this.files)
    },
    saveZip(filezipname, files) {
        filezipname = `SousTitreur-com_${filezipname}`;
        if(files.length === 0) return;
        const zip = new JSZip();

        files.forEach(async (file) => {
          try {
            const blobPromise = fetch(file.url).then((r) => {
                if (r.status === 200) return r.blob();
                return Promise.reject(new Error(r.statusText));
            });
            zip.file(file.filename, blobPromise, { binary: true});
          } catch (err) {
            console.log(err);
          }
        });

        zip.generateAsync({ type: "blob" }).then((content) => saveAs(content, filezipname));
    },
    getFilenameFromUrl(url) {
      let filename = '';
      let tempArray = [];
      tempArray = url.split("/");
      filename = tempArray[tempArray.length - 1];
      if (filename.indexOf('?') > -1) {
        tempArray = filename.split("?");
        filename = tempArray[0];
      }
      if (filename.toLowerCase().search('soustitreur-com_') === -1) {
        filename = `SousTitreur-com_${filename}`;
      }
      return filename;
    },
    rateReview(orderitemid, reviewNote, reviewComment) {
      this.isRated[orderitemid] = true;
      this.saveNote(orderitemid, reviewNote, reviewComment);
    },
    getFullDownloadLink(url) {
      const hostname = this.getHostname();
      return hostname.concat(url);
    },
    async clickedDownload(url, orderitemid){
      const hostname = this.getHostname();
      const fileName = this.getFilenameFromUrl(url);
      if (url.search('https://') === -1) {
        url = hostname.concat(url);
      }
      try {
        this.download(url, fileName);
      } catch(err) {
        console.log({ err })
      }
      this.$refs[`dropdown-divider-${orderitemid}`].style.display = 'block';
      this.$refs[`dropdown-form-${orderitemid}`].style.display = 'block';
    },
    getHostname() {
      var hostname = location.hostname;
      if (hostname.indexOf('local') > -1) {
        hostname = 'https://soustitreur.com.local';
      } else {
        hostname = window.location.origin;
      }
      return hostname;
    },
    download(url, filename) {
      Axios.get(url, {
        responseType: 'blob',
      }).then(res => {
        const contentDisposition = res.headers['content-disposition'];
        const actualFilename = contentDisposition.replace('attachment; filename="', '').replace('"', '');
        this.downloadFile(res.data, actualFilename);
      });
    },
    downloadFile(data, filename, mime) {
      const blob = new Blob([data], { type: mime || 'application/octet-stream' })
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // For IE
        window.navigator.msSaveBlob(blob, filename)
      } else {
        // For other browsers
        const blobURL = window.URL.createObjectURL(blob)
        const tempLink = document.createElement('a')
        tempLink.style.display = 'none'
        tempLink.href = blobURL
        tempLink.setAttribute('download', filename)

        if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank')
        }

        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        window.URL.revokeObjectURL(blobURL)
      }
    },
    getBurnStyleMarginPercentage() {
      const selectedStyle = this.selectedBurnStyle
      if (selectedStyle !== 'OLDSCHOOL' && selectedStyle !== 'METROPOLIS-REMIX') {
        const value = parseFloat(this.burnstylemarginpercentage[selectedStyle] * (1080 / 288) * (100 / 1080)).toFixed(2)
        this.defaultPercentage = value
        this.newPercentage = value
        return this.newPercentage
      } else if (selectedStyle !== 'OLDSCHOOL' && selectedStyle === 'METROPOLIS-REMIX') {
        const value = parseFloat(this.burnstylemarginpercentage.METROPOLIS_REMIX * (1080 / 288) * (100 / 1080)).toFixed(2)
        this.newPercentage = value
        this.defaultPercentage = value
        return this.newPercentage
      } else if (selectedStyle === 'OLDSCHOOL') {
        const value = parseFloat((this.burnstylemarginpercentage.OLDSCHOOL * 100) / 270).toFixed(2)
        this.newPercentage = value
        this.defaultPercentage = value
        return this.newPercentage
      }
      this.defaultPercentage = 0
      this.newPercentage = 0
      return this.newPercentage
    },
    resetDefault() {
      this.newPercentage = this.defaultPercentage
      return this.newPercentage
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 767px) {
  .table-responsive .dropdown-menu {
    position: static !important;
  }
}
@media (min-width: 768px) {
  .table-responsive {
    overflow: visible;
  }
}
</style>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .title-max-width {
    max-width: 380px; 
  }
  .text-light h5.modal-title {
    color:#f6f6f6 !important;
  }
  .onhover-pointer:hover {
    cursor: pointer;
  }
  a.subtitle-download-btn {
    font-family: inherit;
    font-weight: 500;
    font-size: 0.9rem;
    color: #28c76f;
    cursor: pointer;
  }
  a.subtitle-download-btn-item {
    color: #6e6b7b;
    padding-left: 1rem;
    cursor: pointer;
  }
  a.subtitle-download-btn-item:hover {
    color: #28c76f;
    background-color: rgba(40, 199, 111, 0.12);
    text-decoration: none;
    text-decoration-line: none;
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  }
  [dir] .b-dropdown-form {
    padding-bottom: 0rem;
  }
  a.subtitle-download-btn-item:before:disabled {
    opacity: 1;
    width: auto;
  }
  .burn-options-body {
    margin-bottom: 9rem !important;
  }
</style>
